import React, { useEffect, useReducer, useState } from 'react';
import Notification from '../Common/Notification';
import CallOut from '../Common/CallOut';
import TextInput from '../Common/TextInput';
import ActivityLoader from '../Common/ActivityLoader';
import { useStudent } from '../../DataStore/StudentContext';
import ajaxStudent from '../../util/remote/ajaxStudent';

const reducer = (state, action)=>{
        if(action.type === "RESET"){
            return {...initialState}
        }
        return { ...state, [action.type]: action.value };
}

const initialState = {
    documentName: '',
    actualFile: null,
    fileSource: '',
    loading: false,
}

const NewFile = ({studentId}) => {

    const [currentNotify, setNotify] = useState(null);

    const [state, dispatch] = useReducer(reducer, initialState);

     const {getStudentAttachments} = useStudent();



    useEffect(()=>{
        if(currentNotify){
            setTimeout(() => {
                setNotify(null);
            }, 5000);
        }
    }, [currentNotify]);

    const handleSave = async (event) =>{
        event.preventDefault();
        if(state.loading){
            return;
        }

        if(!state.documentName || !state.actualFile){
            setNotify(<Notification type='danger' message="Please fill in all required fields."/>);
            return;
        }
        setNotify(null);
        dispatch({type: 'loading', value: true});
        const server_response = await ajaxStudent.uploadStudentFile({
            student_id: studentId,
            title: state.documentName,
            attachment: state.actualFile
        });
        console.log(server_response);
        dispatch({type: 'loading', value: false});
        if(server_response.status === "OK"){
            setNotify(<Notification type='success' message={server_response.message}/>);
           getStudentAttachments(studentId);
            dispatch({type: 'RESET'});
        } else {
            setNotify(<Notification type='danger' message={server_response.message}/>);
        }

    }


     
     const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (!(file && (file.type === 'application/pdf' || file.type.startsWith('image/')) && file.size <= 1 * 1024 * 1024)) {
            setNotify(<Notification type='danger' message="Invalid file type or size. Only PDF and image files under 5MB are allowed."/>);
            return;
        } 
        dispatch({type: 'fileSource', value: event.target.value});
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (e) => {
        dispatch({type: 'actualFile', value: e.target.result});
        };
    };

  

    return (
        <div className="card-body">

            <CallOut 
                title="Student File"
                description="Upload student files and documents here. Only images and PDF files are allowed."
             />
            {currentNotify}
            <form className="form-horizontal" method="post" onSubmit={handleSave}>

                <TextInput
                    type="text"
                    label="Document Name"
                    placeholder="Enter document name"
                    leftIcon="fa fa-file-alt"
                    value={state.documentName}
                    onChange={e => dispatch({type: 'documentName', value: e.target.value})}
                    required
                    wrap
                    />

                    {/**
                     * Capture file input, maximum size of 1MB
                     * Accepts PDF and image files only
                     */}
                    <TextInput
                        type="file"
                        label="Upload Document"
                        placeholder="Choose file"
                        leftIcon="fa fa-upload"
                        onChange={handleFileChange}
                        required
                        wrap
                        accept=".pdf,image/*"
                        value={state.fileSource}
                        />
                
                

                    <div className="text-right">
                        {!state.loading && <button type="submit" className="btn btn-lg btn-success">Save Document</button>}
                        {state.loading && <ActivityLoader />}
                    </div>

            </form> 


        </div>
    );
};

export default NewFile;